import styled from "styled-components";

const Container = styled.button`
    cursor: pointer;
    display: flex;
    padding: 3px;
    position: relative;
    z-index: 10;
    align-items: center;

    background: #F5F5F5;
    border-radius: 30px;
    color: #9D9D9D;
    font-size: 14px;
    max-width: 176px;
    margin: 0;

    &:disabled {
        cursor: auto;
        background: #d7d7d7;
    }

    span.text {
        font-family: "Inter", sans-serif;
        font-size: 14px;
        margin-top: 0 !important;
        padding: 0 20px 0 10px;
    }

    span.icon {
      background: white;
      width: 30px;
      height: 30px;
      border-radius: 100%;
      margin: 0 !important;
    }

    &:hover span.icon {
        background: #FFE6D1;
        color: #FE902F;
    }
`;

type IconButtonProps = {
    Icon: React.ElementType;
    [key: string]: any;
};

const IconButton: React.FC<IconButtonProps> = ({ Icon, children, ...props }) => {
    return (
        <Container {...props}>
            <span className="icon">
                <Icon />
            </span>
            <span className="text">{children}</span>
        </Container>
    );
};

export default IconButton;
